import React, { useRef, useState } from 'react';

import PropTypes from 'prop-types';
import { Button, Typography } from '@material-ui/core';

import { PromoCodeProvider, usePromoCode } from '../../../hook/usePromoCode';
import Loading from '../../global/OverLoading';
import CreateModal from './CreateModal';
import Filter from './Filter';
import PromoCodeTable from './PromoCodeTable';
import BulkUpdateDeleteModal from './BulkUpdateDeleteModal';

function PromoCode() {
  const { isLoading, filter, onFilterChange } = usePromoCode();

  const [open, setOpen] = useState(false);
  const [isBulkModalOpen, setIsBulkModalOpen] = useState(false);
  const savedFilters = useRef({
    ...filter,
  });

  const onOpenBulkUpdateDeleteModal = () => {
    // Save the last filter before opening the bulkUpdateDelete modal
    savedFilters.current = { ...filter };
    setIsBulkModalOpen(true);
  };

  const onCloseBulkUpdateDeleteModal = () => {
    // Restore the last filter
    onFilterChange(savedFilters.current);
    setIsBulkModalOpen(false);
  };

  return (
    <>
      { isLoading && <Loading />}
      <div className="row" style={{ rowGap: 24 }}>
        <div className="col-12 col-md-4">
          <Typography variant="h5">Promo codes</Typography>
        </div>
        <div className="col-12 col-md-8">
          <div className="d-flex justify-content-end" style={{ columnGap: 12 }}>
            <Button variant="contained" color="white" component="span" onClick={onOpenBulkUpdateDeleteModal}>
              Bulk Update/Delete
            </Button>
            <Button variant="contained" color="primary" component="span" onClick={() => setOpen(true)}>
              Create promo code
            </Button>
          </div>
        </div>
      </div>
      <div className="d-flex justify-content-end mt-3" />
      <Filter />
      <PromoCodeTable />
      <CreateModal open={open} onClose={() => setOpen(false)} />
      <BulkUpdateDeleteModal
        open={isBulkModalOpen}
        onClose={onCloseBulkUpdateDeleteModal}
      />
    </>
  );
}

function PromoCodeWrapper({ match }) {
  return (
    <PromoCodeProvider match={match}>
      <PromoCode />
    </PromoCodeProvider>
  );
}

PromoCodeWrapper.propTypes = {
  match: PropTypes.shape(Object).isRequired,
};

export default PromoCodeWrapper;
